import { CreditReport } from '../types/credit'

export const borrower = {
  name: 'Jordan A. Whitfield',
  coBorrower: 'Maya R. Whitfield',
  loanNumber: '1004872-FHA',
  ssnMasked: '***-**-4821',
}

export const creditReports: CreditReport[] = [
  {
    id: 'rpt-3',
    bureauLabel: 'Tri-Merge',
    bureaus: ['Equifax', 'Experian', 'TransUnion'],
    provider: 'Factual Data',
    pulledOn: 'Jul 22, 2026',
    pulledBy: 'Dana Reyes',
    scores: [
      { bureau: 'EQ', score: 728 },
      { bureau: 'EX', score: 741 },
      { bureau: 'TU', score: 719 },
    ],
    liabilities: [
      {
        id: 'r3-1',
        creditor: 'Chase Auto Finance',
        accountType: 'Installment',
        accountNumber: '****4402',
        owner: 'Borrower',
        balance: 18420,
        monthlyPayment: 412,
        status: 'Open',
        alreadyPushed: false,
      },
      {
        id: 'r3-2',
        creditor: 'Capital One Platinum',
        accountType: 'Revolving',
        accountNumber: '****9930',
        owner: 'Borrower',
        balance: 2340,
        monthlyPayment: 65,
        status: 'Open',
        alreadyPushed: false,
      },
      {
        id: 'r3-3',
        creditor: 'Navient Student Loan',
        accountType: 'Installment',
        accountNumber: '****1187',
        owner: 'Borrower',
        balance: 24870,
        monthlyPayment: 268,
        status: 'Open',
        alreadyPushed: true,
      },
      {
        id: 'r3-4',
        creditor: 'Wells Fargo Mortgage',
        accountType: 'Mortgage',
        accountNumber: '****7715',
        owner: 'Joint',
        balance: 214300,
        monthlyPayment: 1685,
        status: 'Open',
        alreadyPushed: false,
      },
      {
        id: 'r3-5',
        creditor: 'Discover It',
        accountType: 'Revolving',
        accountNumber: '****2261',
        owner: 'Co-Borrower',
        balance: 890,
        monthlyPayment: 35,
        status: 'Open',
        alreadyPushed: false,
      },
      {
        id: 'r3-6',
        creditor: 'Midland Credit Mgmt',
        accountType: 'Collection',
        accountNumber: '****0043',
        owner: 'Borrower',
        balance: 612,
        monthlyPayment: 0,
        status: 'Collection',
        alreadyPushed: false,
      },
      {
        id: 'r3-7',
        creditor: 'Best Buy / CBNA',
        accountType: 'Revolving',
        accountNumber: '****5518',
        owner: 'Borrower',
        balance: 0,
        monthlyPayment: 0,
        status: 'Closed',
        alreadyPushed: false,
      },
    ],
  },
  {
    id: 'rpt-2',
    bureauLabel: 'Tri-Merge',
    bureaus: ['Equifax', 'Experian', 'TransUnion'],
    provider: 'CoreLogic Credco',
    pulledOn: 'Jun 08, 2026',
    pulledBy: 'Dana Reyes',
    scores: [
      { bureau: 'EQ', score: 715 },
      { bureau: 'EX', score: 733 },
      { bureau: 'TU', score: 708 },
    ],
    liabilities: [
      {
        id: 'r2-1',
        creditor: 'Chase Auto Finance',
        accountType: 'Installment',
        accountNumber: '****4402',
        owner: 'Borrower',
        balance: 20150,
        monthlyPayment: 412,
        status: 'Open',
        alreadyPushed: false,
      },
      {
        id: 'r2-2',
        creditor: 'Capital One Platinum',
        accountType: 'Revolving',
        accountNumber: '****9930',
        owner: 'Borrower',
        balance: 3110,
        monthlyPayment: 78,
        status: 'Open',
        alreadyPushed: false,
      },
      {
        id: 'r2-3',
        creditor: 'Navient Student Loan',
        accountType: 'Installment',
        accountNumber: '****1187',
        owner: 'Borrower',
        balance: 25320,
        monthlyPayment: 268,
        status: 'Open',
        alreadyPushed: false,
      },
      {
        id: 'r2-4',
        creditor: 'Wells Fargo Mortgage',
        accountType: 'Mortgage',
        accountNumber: '****7715',
        owner: 'Joint',
        balance: 216900,
        monthlyPayment: 1685,
        status: 'Open',
        alreadyPushed: false,
      },
      {
        id: 'r2-5',
        creditor: 'Midland Credit Mgmt',
        accountType: 'Collection',
        accountNumber: '****0043',
        owner: 'Borrower',
        balance: 612,
        monthlyPayment: 0,
        status: 'Collection',
        alreadyPushed: false,
      },
    ],
  },
  {
    id: 'rpt-1',
    bureauLabel: 'Single Bureau',
    bureaus: ['Experian'],
    provider: 'Factual Data',
    pulledOn: 'Apr 15, 2026',
    pulledBy: 'Chris Nolan',
    scores: [{ bureau: 'EX', score: 726 }],
    liabilities: [
      {
        id: 'r1-1',
        creditor: 'Chase Auto Finance',
        accountType: 'Installment',
        accountNumber: '****4402',
        owner: 'Borrower',
        balance: 22740,
        monthlyPayment: 412,
        status: 'Open',
        alreadyPushed: false,
      },
      {
        id: 'r1-2',
        creditor: 'Navient Student Loan',
        accountType: 'Installment',
        accountNumber: '****1187',
        owner: 'Borrower',
        balance: 25980,
        monthlyPayment: 268,
        status: 'Open',
        alreadyPushed: false,
      },
      {
        id: 'r1-3',
        creditor: 'Amex Blue Cash',
        accountType: 'Revolving',
        accountNumber: '****3390',
        owner: 'Borrower',
        balance: 1420,
        monthlyPayment: 40,
        status: 'Closed',
        alreadyPushed: false,
      },
    ],
  },
]

export function formatCurrency(value: number): string {
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  })
}
